export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13109.071e6023.jpg";